import * as React from 'react'
import { WorkingMessageListConnected } from './WorkingMessageListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const WorkingMessageListExamples = () => {
  return (
    <div className="WorkingMessageListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <WorkingMessageListConnected />
      </Provider>
    </div>
  )
}
